/**
 * POP Self Service System
 * Copyright 2016 POP Global Limited
 *
 * Authors:
 * Fuhang Wang <fuhang@wegotpop.com>
 */
// ===========================
// Events related to Category:
// ===========================
const EDIT_CTG = 'EDIT_CTG';
const CANCEL_CTG_EDIT = 'CANCEL_CTG_EDIT';
const EXPAND_CTG = 'EXPAND_CTG';
const COLLAPSE_CTG = 'COLLAPSE_CTG';

// ===========================
// Events related to Question:
// ===========================
const EDIT_QST = 'EDIT_QST';
const CANCEL_QST_EDIT = 'CANCEL_QST_EDIT';
const EXPAND_QST = 'EXPAND_QST';
const COLLAPSE_QST = 'COLLAPSE_QST';

// ======================================
// Events related to server interactions:
// ======================================
const LOAD_FAQS_START = 'LOAD_FAQS_START';
const LOAD_FAQS_SUCCESSFUL = 'LOAD_FAQS_SUCCESSFUL';
const LOAD_FAQS_FAILED = 'LOAD_FAQS_FAILED';

const LOAD_EDIT_PERM = 'LOAD_EDIT_PERM';
const LOAD_EDIT_GLOBAL_PERM = 'LOAD_EDIT_GLOBAL_PERM';

const ADD_CTG_START = 'ADD_CTG_START';
const ADD_CTG_SUCCESSFUL = 'ADD_CTG_SUCCESSFUL';
const ADD_CTG_FAILED = 'ADD_CTG_FAILED';
const UPDATE_CTG_START = 'UPDATE_CTG_START';
const UPDATE_CTG_SUCCESSFUL = 'UPDATE_CTG_SUCCESSFUL';
const UPDATE_CTG_FAILED = 'UPDATE_CTG_FAILED';
const DELETE_CTG_START = 'DELETE_CTG_START';
const DELETE_CTG_SUCCESSFUL = 'DELETE_CTG_SUCCESSFUL';
const DELETE_CTG_FAILED = 'DELETE_CTG_FAILED';

const ADD_QST_START = 'ADD_QST_START';
const ADD_QST_SUCCESSFUL = 'ADD_QST_SUCCESSFUL';
const ADD_QST_FAILED = 'ADD_QST_FAILED';
const UPDATE_QST_START = 'UPDATE_QST_START';
const UPDATE_QST_SUCCESSFUL = 'UPDATE_QST_SUCCESSFUL';
const UPDATE_QST_FAILED = 'UPDATE_QST_FAILED';
const DELETE_QST_START = 'DELETE_QST_START';
const DELETE_QST_SUCCESSFUL = 'DELETE_QST_SUCCESSFUL';
const DELETE_QST_FAILED = 'DELETE_QST_FAILED';

// ==================
// User action types:
// ==================
export const ACTION_TYPES = {
  LOAD_FAQS_START,
  LOAD_FAQS_SUCCESSFUL,
  LOAD_FAQS_FAILED,
  LOAD_EDIT_PERM,
  LOAD_EDIT_GLOBAL_PERM,
  ADD_CTG_START,
  ADD_CTG_SUCCESSFUL,
  ADD_CTG_FAILED,
  DELETE_CTG_START,
  DELETE_CTG_SUCCESSFUL,
  DELETE_CTG_FAILED,
  UPDATE_CTG_START,
  UPDATE_CTG_SUCCESSFUL,
  UPDATE_CTG_FAILED,
  EDIT_CTG,
  CANCEL_CTG_EDIT,
  EXPAND_CTG,
  COLLAPSE_CTG,
  ADD_QST_START,
  ADD_QST_SUCCESSFUL,
  ADD_QST_FAILED,
  DELETE_QST_START,
  DELETE_QST_SUCCESSFUL,
  DELETE_QST_FAILED,
  UPDATE_QST_START,
  UPDATE_QST_SUCCESSFUL,
  UPDATE_QST_FAILED,
  EDIT_QST,
  CANCEL_QST_EDIT,
  EXPAND_QST,
  COLLAPSE_QST,
};

// ========================
// User interaction states:
// ========================
const IN_EDITING = 'IN_EDITING';
const EXPANDED = 'EXPANDED';
const EDIT_PERM = 'EDIT_PERM';
const EDIT_GLOBAL_PERM = 'EDIT_GLOBAL_PERM';

export const USER_OPR_STATE = {
  IN_EDITING,
  EXPANDED,
  EDIT_PERM,
  EDIT_GLOBAL_PERM,
};

// ==========================
// Server interaction states:
// ==========================
const ADD = 'ADD';
const ADDING = 'ADDING';
const ADDING_SUCCESSFUL = 'ADDING_SUCCESSFUL';
const ADDING_FAILED = 'ADDING_FAILED';

const LOAD = 'LOAD';
const LOADING = 'LOADING';
const LOADING_SUCCESSFUL = 'LOADING_SUCCESSFUL';
const LOADING_FAILED = 'LOADING_FAILED';

const UPDATE = 'UPDATE';
const UPDATING = 'UPDATING';
const UPDATING_SUCCESSFUL = 'UPDATING_SUCCESSFUL';
const UPDATING_FAILED = 'UPDATING_FAILED';

const DELETE = 'DELETE';
const DELETING = 'DELETING';
const DELETING_SUCCESSFUL = 'DELETING_SUCCESSFUL';
const DELETING_FAILED = 'DELETING_FAILED';

export const SERVER_OPR_STATE = {
  ADD,
  ADDING,
  ADDING_SUCCESSFUL,
  ADDING_FAILED,
  LOAD,
  LOADING,
  LOADING_SUCCESSFUL,
  LOADING_FAILED,
  UPDATE,
  UPDATING,
  UPDATING_SUCCESSFUL,
  UPDATING_FAILED,
  DELETE,
  DELETING,
  DELETING_SUCCESSFUL,
  DELETING_FAILED,
};

export const CATEGORY_DELETING_TITLE = 'Delete category';
export const CATEGORY_DELETING_MSG =
  'You are about to delete a category. ' +
  'Deleting categories will also delete any questions inside of those categories. ' +
  'This action cannot be undone. Do you wish to proceed?';
export const CATEGORY_DELETING_YES = 'Yes';
export const CATEGORY_DELETING_NO = 'No';
